import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class ParentDelaerService {

  constructor(private ws: PostmethodService) { }

  createDealer(request: any) {
    return this.ws.wsPost(request, environment.baseUrl + "masters/dealer");
  }

  updateDealer(request: any, id: any) {
    return this.ws.wsPut(request, environment.baseUrl + "masters/dealer", id);
  }

  getParentDealer() {
    return this.ws.wsGet(environment.baseUrl + "masters/dealer");
  }

  getCountry() {
    return this.ws.wsGet(environment.baseUrl + "masters/countries");
  }

  getZoneByCountry(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "/common/get-zones-by-country", id);
  }

  getStateByZone(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "common/get-states-by-zone", id);
  }

  getRegionByState(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "common/get-regions-by-state", id);
  }

  getDistrictByRegion(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "common/get-districts-by-region", id);
  }

  getAreaByDistrict(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "common/get-areas-by-district", id);
  }

  getLocationByArea(id: any) {
    return this.ws.wsGetById(environment.baseUrl + "common/get-location-by-area", id);
  }

  getExport() {
    return this.ws.wsGet(environment.baseUrl + "reports/userExportParentDealerReport");
  }

  getUserList(id: any, type: string) {
    //  return this.ws.wsGetById(environment.baseUrl + "masters/outlet/outletUser" + `?type=${type}`, id);

    return this.ws.wsGet(
      `${environment.baseUrl}masters/outlet/outletUser/${id}?type=${type}`
    );
  }

}
